import React, { lazy } from 'react';

const AdminLogin = lazy(() => import('@/pages/admin/login'));
const AdminHome = lazy(() => import('@/pages/admin/home'));
const AdminMain = lazy(() => import('@/pages/admin/main'));
const UserSearch = lazy(() => import('@/pages/admin/userSearch'));
const ConsultantsManagement = lazy(() => import('@/pages/admin/consultants'));
const AuditList = lazy(() => import('@/pages/admin/auditList'));
const EvaluationManagement = lazy(() => import('@/pages/admin/evaluationManagement'));
const AuditPage = lazy(() => import('@/pages/admin/auditPage'));
const ConsultantDetailInfo = lazy(() => import('@/pages/admin/consultantDetailInfo'));
const ConsultingComment = lazy(() => import('@/pages/admin/consultingComment'));
const AdminConsultantDialogue = lazy(() => import('@/pages/admin/dialogue'));
const ArrangeCalendar = lazy(() => import('@/pages/admin/arrangeCalendar'));
const ConsultationRecordForm = lazy(() => import('@/pages/admin/consultationRecordForm'));
const StaffDetail = lazy(() => import('@/pages/admin/staffDetail'));
const ChatRecord = lazy(() => import("@/pages/admin/chatRecord"));
const AdminHealthRecordList = lazy(() => import('@/pages/admin/healthRecordList'));
const AdminRecordDetail = lazy(() => import('@/pages/admin/healthRecordList/recordDetail'));

const adminRouters = [
  { path: '/admin/login', component: <AdminLogin />, needInterceptor: false },
  {
    path: '/admin/home', component: <AdminHome />, children: [
      { path: 'main', component: <AdminMain />, needInterceptor: true },
      { path: 'consultants', component: <ConsultantsManagement />, needInterceptor: true },
      { path: 'visitors', component: <UserSearch />, needInterceptor: true },
      { path: 'user-setting', component: <AdminMain />, needInterceptor: true },
    ]
  },
  { path: '/admin/evaluation-management', component: <EvaluationManagement />, needInterceptor: true },
  { path: '/admin/audit-list', component: <AuditList />, needInterceptor: true },
  { path: '/admin/audit-page', component: <AuditPage />, needInterceptor: true },
  { path: '/admin/consultant-detail-info', component: <ConsultantDetailInfo />, needInterceptor: true },
  { path: '/admin/consultant-comment', component: <ConsultingComment />, needInterceptor: true },
  { path: '/admin/dialogue', component: <AdminConsultantDialogue />, needInterceptor: true },
  { path: '/admin/arrange-calendar', component: <ArrangeCalendar />, needInterceptor: true },
  { path: '/admin/consultation-record-form', component: <ConsultationRecordForm />, needInterceptor: true },
  { path: '/admin/staff-detail', component: <StaffDetail />, needInterceptor: true },
  { path: '/admin/chat-record', component: <ChatRecord />, needInterceptor: true },
  { path: '/admin/health-record-list', component: <AdminHealthRecordList />, needInterceptor: true },
  { path: '/admin/record-detail', component: <AdminRecordDetail />, needInterceptor: true },
];

export default adminRouters;
